module.exports = __webpack_public_path__ + "img/icn_storage_distribution3.9231cb0a.png";